// extracted by mini-css-extract-plugin
export default {"feature_nav":"feature_feature_nav__Ah2zG","btn":"feature_btn__WXfH3"};